import React from 'react'

import { corDash as cor } from '../../../utils/dashboard'
import { formatarMilharSemDecimais } from '../../../utils/formatarMilhar'

export default function LabelGraficosPizzaComposto({ viewBox, valorPercentual }) {
  const localTema = localStorage.getItem('tema')
  const { cx } = viewBox
  let auxTooltipTotal
  const auxValPerc = parseFloat(valorPercentual)

  if (auxValPerc > 2000000) {
    auxTooltipTotal =
      parseFloat(valorPercentual / 1000000).toFixed(1) + ' milhões'
  } else if (auxValPerc > 1000000) {
    auxTooltipTotal =
      parseFloat(valorPercentual / 1000000).toFixed(1) + ' milhão'
  } else if (auxValPerc > 1000) {
    auxTooltipTotal = parseFloat(valorPercentual / 1000).toFixed(1) + ' mil'
  } else {
    auxTooltipTotal = formatarMilharSemDecimais(valorPercentual)
  }
  return (
    <>
      <text
        className="texto-titulo-legenda-grafico-pizza-grande-dash"
        x={cx}
        y="44%"
        fill={
          localTema === 'claro' || localTema === 'algarClaro'
            ? cor.preto
            : cor.branco
        }
        textAnchor="middle"
        dominantBaseline="central"
      >
        Total
      </text>
      <text
        className="label-percentual-graficos-pizza-composto-dash"
        x={cx}
        y="53%"
        fill={
          localTema === 'claro' || localTema === 'algarClaro'
            ? cor.preto
            : cor.branco
        }
        textAnchor="middle"
        dominantBaseline="central"
      >
        {auxTooltipTotal}
      </text>
    </>
  )
}